<script lang="ts">
</script>

<footer class="sticky">
    <p>Sito fatto a mano da me con tanto affetto</p>
</footer>